<template>
  <IconLucideImagePlus />
</template>
